export default {
  
  episodes: [
    {
      id: 8,
      name: "Episode 8",
      streamURL:105159,
    },
    {
      id: 7,
      name: "Episode 7",
      streamURL:105158,

    },
    {
      id: 6,
      name: "Episode 6: Et oppsiktsvekkende funn",
      streamURL:104933,
      podURL:"https://www.aftenbladet.no/podkast/sa/episode/104871"
    },
    {
      id: 5,
      name: "5",
      streamURL:104871,
      podURL:"https://www.aftenbladet.no/podkast/sa/episode/104871"
    },
    
    {
      id: 4,
      name: "4",
      streamURL:104864,
      podURL:"https://www.aftenbladet.no/podkast/sa/episode/104864"
    },
    {
      id: 3,
      name: "3",
      streamURL:104863,
      podURL:"https://www.aftenbladet.no/podkast/sa/episode/104863"
    },
    {
      id: 2,
      name: "2",
      streamURL:104860,
      episode: 2,
    },
    {
      id: 1,
      name: "1",
      streamURL:104859,
      episode: 1,
    },
    {
      id: 9,
      name: "Missing",
      streamURL:104807,
    },
  ],
  people: [
    {
      id: 1,
      name: "lapper_med_navn/profil_lapper_Reidar.png",
      description:
        "66-åringen fra Sauda forsvant sporløst i nærheten av den brasilianske millionbyen Recife ved årsskiftet 2013/2014. Trebarnsfaren har aldri kommet til rette, og ingen levninger er funnet. Reidar hadde etablert seg med ny familie i Brasil, men fortsatte å jobbe lange strekk som stuert i et trålerrederi på Sunnmøre. Da han forsvant skal forholdet til brasilianske kvinnen han er en datter med ha vært over. Det siste året før han ble borte tilbrakte Reidar det meste av sine friperioder på den afrikanske øystaten Kapp Verde. Flere mystiske omstendigheter gjør at både familien i Norge og politiet frykter at Reidar ble utsatt for en alvorlig kriminell handling.",
      picture: "reidar_fristilt.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 3, 4, 5, 6, 7],
    },
    {
      id: 2,
      name: "lapper_med_navn/profil_lapper_Preben.png",
      description:
        "Reidars sønn fra hans første ekteskap, f. 1978. Oppvokst i Sauda, men har de siste årene vært bosatt i Stavanger. Han slet i mange år med narkotikaproblemer, men har kommet seg ut av avhengigheten. Preben er i dag blant annet brukerkonsulent for Rusmisbrukernes Interesseorganisasjon (RIO). Preben er egentlig sikker på at Reidar ikke lenger er i live, men et sted langt inne i seg håper han at faren er et sted der ute og at han skal få se ham igjen.",
      picture: "preben.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 3,
      name: "lapper_med_navn/profil_lapper_Rudy.png",
      description:
        "Reidars datter fra hans andre ekteskap, f. 1987. Bosatt i Bergen, der hun jobber i forsikringsbransjen. Da Reidar kom til Norge for å bære Rudys datter til dåpen i januar 2013, var det siste gang hun så ham. Rudy er sikker på at faren er død, og forteller at datteren har hatt mareritt om at noen tok morfar med ut i skogen og skjøt ham.",
      picture: "rudy.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 4,
      name: "lapper_med_navn/profil_lapper_anne-grete.png",
      description:
        "Reidars ett år yngre søster. Pensjonist. Anne Grete har bodd i Sauda hele livet. Anne Grete var gift med Terje Michalsen, som var Reidars beste venn. Anne Grete er sikker på at noen skjuler en stor hemmelighet rundt storebrorens forsvinning. Hun tror hun vet hvem.",
      picture: "soster2_v2.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 5,
      name: "lapper_med_navn/profil_lapper_leif-kåre.png",
      description:
        "Reidars bror. Hadde kontakt med Reidar på chat og telefon, og besøkte ham også flere ganger i Brasil, der han traff Reidars brasilianske familie. Han hadde et godt inntrykk av brorens samboer. Da Leif Kåre døde av kreft i januar 2016, ble også Reidar minnet under begravelsen. På dødsleiet håpet Leif Kåre fortsatt at det kunne være en mulighet for at Reidar fortsatt levde. Kanskje hadde storebroren bare stukket fra alt?",
      picture: "leifkare.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 6,
      name: "lapper_med_navn/profil_lapper_bjørg-nina.png",
      description:
        "Reidars yngste søster. Ansatt i helsesektoren. Bosatt i Sauda. Like før jul i 2013, mindre enn to uker før han ble borte, fortalte Reidar henne at han ville hjem til Norge. Bjørg-Nina er sikker på at Reidar er død. Han ville aldri bare forlatt sine aller nærmeste uten å gi beskjed til noen. Alt det rare som skjedde etter at Reidar forsvant, har fått Bjørg-Nina til å frykte det verste.",
      picture: "soster1_v2.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 16,
      name: "lapper_med_navn/kristina-n-berge.png",
      description:
        "Datter av Reidars bror, Leif-Kåre. Eier huset til farmoren, som døde i 2011. I desember 2013 skrev Reidar til henne at han ville flytte hjem til Norge tidlig i 2014. Kunne han kunne få bo i loftsleiligheten i morens gamle hus? Da hun en måned senere fikk gebrokken melding fra Reidars Facebook-profil om at han ikke kom likevel, fikk Kristina mistanke om at noe var alvorlig galt. ",
      picture: "kristina-n-berge_v2.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 7,
      name: "lapper_med_navn/profil_lapper_Wahl.png",
      description:
        "Politioverbetjent i Sør-Vest politidistrikt. Thomas Wahl hadde ansvaret for politiundersøkelsene etter at Reidar ble meldt savnet. Politimannen mener det er mye som skurrer i saken, og har en dårlig følelse.",
      picture: "wahl_fristilt.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 8,
      name: "lapper_med_navn/profil_lapper_Utne-pettersen.png",
      description:
        "Politiinspektør i Sør-Vest politidistrikt. Var i lange perioder påtalemessig ansvarlig for undersøkelsene av Reidars savnet-melding. Thomas Utne Pettersen frykter at noe alvorlig kan ha tilstøtt Reidar, og lurer fortsatt på om norsk politi likevel burde ha trykket på “den røde knappen”.",
      picture: "utne.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 12,
      name: "lapper_med_navn/profil_lapper_paula.png",
      description:
        "Reidars samboer i Brasil. Paula hadde en datter fra før. Hun og Reidar møttes i 2005. Ikke lenge etter flyttet de tre sammen. I august 2007 fikk Reidar og Paula datteren “Adele” sammen. Ifølge Reidar tok forholdet slutt et drøyt års tid før han forsvant. Paula og døtrene ble boende i leiligheten. Reidar bodde også der når han var i Brasil, selv om det var slutt med Paula. Paula frykter Reidar ble ranet og drept for penger. Paula er ikke den brasilianske kvinnens egentlige navn.",
      picture: "paula.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 13,
      name: "lapper_med_navn/profil_lapper_Adele.png",
      description:
        "Datteren Reidar fikk med samboeren i Brasil, Paula. Reidar fortalte ofte sin familie i Norge og sine venner hvor glad han var i Adele og datteren Paula hadde fra før. Adele var 7 år da faren forsvant. Hun savner ham. Adele er ikke Reidars datters egentlige navn.",
      picture: "adele.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 14,
      name: "lapper_med_navn/profil_lapper_ana-lucila.png",
      description:
        "Adeles halvsøster, og Paulas datter fra et tidligere forhold. Ana Lucila, var seks år da moren møtte Reidar. Ana Lucila er ikke hennes egentlige navn.",
      picture: "analucia.png",
      cls: "bg",  
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    {
      id: 15,
      name: "lapper_med_navn/profil_lapper_bareiere.png",
      description:
        "Ektepar som driver en posada (gjestgiveri) i den lille strandbyen Ponta de Pedras, en drøy times kjøring nord for Recife. Paula sier at Reidar dro til byen i slutten av mars 2014 for å se etter et lokale der han selv kunne sette opp en restaurant eller et gjestgiveri. Paula sier at det var da hun mistet kontakten. Var det Reidar Eroni mottok som gjest da en utlending dukket opp i resepsjonen med en kvinne rundt månedsskiftet mars-april 2014? ",
      picture: "pistone_buss_fristilt.png",
      cls: "bg",
      relatedArticles: [],
      inEpisodes: [1, 2, 4],
    },
    // {
    //   id: 16,
    //   name: "lapper_med_navn/profil_lapper_da-silva.png",
    //   description:
    //     "Reidars venn på Kapp Verde. Også kjent som “Tony”. I slutten av oktober 2013 fortalte nordmannen at han skulle til Brasil for å besøke datteren og selge en leilighet han eide. Så hørte han aldri mer fra sin norske kamerat. “Tony” har aldri klart å glemme Reidar, og lurer på hva som skjedde med ham.",
    //   picture: "dasilva.png",
    //   cls: "bg",
    //   relatedArticles: [],
    //   inEpisodes: [1, 2, 4],
    // },
    // {
    //   id: 17,
    //   name: "lapper_med_navn/profil_lapper_celine.png",
    //   description:
    //     "Reidars venninne på Kapp Verde. Møtte den norske sjømannen i januar 2013 og hadde et kort forhold til ham. Ikke lenge etter at hun traff Reidar fikk hun en aggressiv melding på Messenger fra Paula i Brasil.",
    //   picture: "celine.png",
    //   cls: "bg",
    //   relatedArticles: [],
    //   inEpisodes: [1, 2, 4],
    // },
    // {
    //   id: 18,
    //   name: "lapper_med_navn/profil_lapper_elsa.png",
    //   description:
    //     "Reidars venninne på Kapp Verde. Skal ha vært Reidars kjæreste høsten 2013. Reidar sa han skulle komme tilbake til Elsa etter at han hadde vært i Brasil. I stedet ble alt stille. Hun har imidlertid hatt flere krangler med Reidars eks-kjæreste.",
    //   picture: "elsa.png",
    //   cls: "bg",
    //   relatedArticles: [],
    //   inEpisodes: [1, 2, 4],
    // },
    // {
    //   id: 19,
    //   name: "lapper_med_navn/profil_lapper_Carla.png",
    //   description:
    //     "Reidars venninne på Kapp Verde. Carla forteller at hun vasket for Reidar. Flyttet til Massachusetts i USA i januar 2014. Ifølge Paula mente Reidar det var Carla som utga seg for å være ham i sosiale medier og på mail.",
    //   picture: "carla.png",
    //   cls: "bg",
    //   relatedArticles: [],
    //   inEpisodes: [1, 2, 4],
    // },
  ],
  places: [
    {
      id: 1,
      name: "lapper/steder_lapper_recife.png",
      location: "PARADISETS MØRKE SIDE",
      picture: "brasil_1.jpg",
      description: [
        "Recife er hovedstaden i den brasilianske delstaten Pernambuco. Mer enn 1,6 millioner mennesker bor i selve byen, men telles hele storbyområdet med, vokser befolkningen til godt over fire millioner.",
        "Klimaet er fantastisk. Turister fra hele verden kommer for å nyte solen og strendene, og for å besøke historiske steder i byen som også omtales som Brasils Venezia.",
        "Allerede i 1537 koloniserte portugiserne området, blant annet for å opprette den første slavehavnen på det amerikanske kontinentet. Gjennom årene ble tusenvis av slaver fra Afrika fraktet til Recife som arbeidskraft til særlig sukkerindustrien.",
        "Sukkerindustrien gjorde området rundt Recife svært velstående. I dag er Recife et senter for industri, finansnæring, turisme og høyere utdanning. ",
        "Men idyllen har en bakside. Fattigdom i store deler av befolkningen og stor sosial ulikhet har gjort både Recife og andre byer i det nordøstre Brasil, som Natal og Fortaleza, til steder med noen av de høyeste drapsratene i verden.",
        "I 2013, det året Reidar Edvin Sandanger fra Sauda reiste til Recife for siste gang, var byen ifølge en internasjonal statistikk over drap den 39. farligste byen i verden. 1 416 mennesker ble drept i Recife i 2013.",
        "Innbyggerne i området sliter med korrupsjon, væpnede ran og kidnapping for løsepenger.",
        "Like nord for Recife ligger Camaragibe, der Sauda-mannen Reidar Sandanger i mars 2007 etablerte seg med sin nye familie. Camaragibe har drøyt 150.000 innbyggere, og regnes som en av de fattigste i Stor-Recife."
      ],
    },
    {
      id: 2,
      name: "lapper/steder_lapper_Sauda.png",
      location: "BYGDA SOM SÅ UT I VERDEN",
      picture: "sauda.jpg",
      description: [
        "Sauda er en bykommune i Ryfylke. Ved inngangen til 2020 bodde 4552 mennesker der. De langt fleste bor i kommunesenteret, som er lokalisert der Storelva renner ut i Saudafjorden.",
        "Tilgangen til fossefall og strie stryk har vært livsnerven i samfunnet, og Sauda er en av Norges største kraftkommuner. Energien fra elva er også utgangspunkt for industrien som vokste frem tidlig i forrige århundre.",
        "I 1923 startet produksjon av ferromangan på Sauda smelteverk. De amerikanske eierne hadde lovet norske myndigheter å utvikle Sauda med blant annet hus til arbeidere, sykehus, styrket polititjeneste og butikk for å få lov til å utnytte vannkraften fra Ryfylke-fjellene. Slik ble et lite jordbrukssamfunn forandret for alltid.",
        "Med industrialiseringen vokste innbyggertallet kraftig. Arbeidere fra hele landet strømmet til. Sauda er kjent for sterk klassebevissthet, og har stort sett vært styrt av arbeiderpartiordførere i hele etterkrigstiden.",
        "I Sauda var det vanlig at sønner fulgte fedre som ansatte på smelteverket. Smelteverket brakte også mange store, internasjonale skip til Sauda. Disse satte fantasien i sving hos de unge. Etter krigen søkte mange saudabuer hyre på skip i utenriksfart. ",
        "Tidlig på 1960-tallet jobbet nesten 1500 mennesker bak fabrikkporten, men så sank antallet innbyggere i Sauda. I dag er det knapt 200 arbeidsplasser på smelteverket (nå Eramet Norway). Men nye virksomheter har kommet til, og fra 2007 har kommunen klart å stabilisere befolkningstallet."
      ],
    },
    {
      id: 3,
      name: "lapper/steder_lapper_Kapp-Verde.png",
      location: "ØYENE DER REIDAR DRØMTE OM ET NYTT LIV",
      picture: "kappverde_1.jpg",
      description: [
        "Kapp Verde er en øygruppe i Atlanterhavet, 57 mil vest for det afrikanske fastlandet. Ved inngangen til 2020 bor det drøyt 550.000 mennesker på de ni bebodde øyene som utgjør nasjonen.",
        "Øygruppen var ubebodd da portugisiske sjømenn oppdaget den på 1400-tallet. På grunn av beliggenheten ble Kapp Verde raskt et knutepunkt for handelsruter og slavetrafikk til Brasil og Latin-Amerika.",
        "Kapp Verde var under portugisisk styre frem til 1975. Da hadde en væpnet frigjøringskamp pågått siden 1959. De neste 15 årene var nasjonen en sosialistisk ettpartistat, med bånd til blant annet Kina og Libya.",
        "Fra 1990 har øygruppen vært et parlamentarisk demokrati og regnes nå som et av de mest stabile demokratiene i Afrika.",
        "De siste årene har Kapp Verde satset stort på turisme. Med rundt 350 soldager i året og svalende vind ligger alt til rette for avslappende dager for gjester fra andre deler av verden.",
        "I januar 2013 var Reidar Edvin Sandanger en av utlendingene som tok turen til Praia for å nyte livet. Det var tilsynelatende slutt mellom den da 65 år gamle Sauda-mannen og hans mangeårige samboer i Brasil. De neste månedene tilbrakte han det meste av tiden han ikke var på fiske med Møre-tråleren “Nordstar” på den afrikanske øygruppen.",
        "23. oktober 2013 satte Reidar seg på et fly fra Praia til Fortaleza i Brasil. Han kom aldri tilbake.",
      ],
    },
  ],
  extra: {
    ep1: [
      {
        "id":1,
        "type":"imggroup",
        "content":["ep1-1.jpg","ep1-2.jpg"],
        "imgClass":"border rotate img-group imgs",
        "class":""
      },
      {
        "id":2,
        "type":"text",
        "content":"Reidar Sandanger ble født i Sauda 26. februar 1947. Han beskrives som en aktiv gutt med mye lopper og ramp i blodet."
      },
      {
        "id":3,
        "type":"img",
        "content":"ep1-3.png",
        "class":"right",
        "imgClass":"right-img"
        
      },
      {
        "id":4,
        "type":"text",
        "content":"Både Stavanger Aftenblad og New York Times skrev om Buøy-ferja som ble stjålet 22. januar 1969. Tyveriet har vert uoppklart frem til nå, men nå vet vi hvem som sto bak. Det var Reidar."
      },
      {
        "id":5,
        "type":"img",
        "content":"ep1-4.png",
        "class":"left",
        "imgClass":"left-img"
      },
      {
        "id":6,
        "type":"imggroup",
        "content":["ep1-5.png","ep1-6.png"],
        "imgClass":"rotate img-group imgs",
        "class":""
      },
      {
        "id":7,
        "type":"text",
        "content":"Reidar var sjømann store deler av livet, og var i løpet av sin karriere som kokk og stuert ombord i rundt seksti skip. (Reidar t.v i byssa på ett av skipene.)"
      },
      {
        "id":13,
        "type":"imggroup",
        "content":["ep1-11.jpg","ep1-12.jpg"],
        "imgClass":"rotate img-group border imgs",
        "class":""
      },
      {
        "id":14,
        "type":"text",
        "content":"I 1977 giftet Reidar seg med Oddrun Birkeland fra Sauda. Året etter fikk de sønnen Preben."
      },
      {
        "id":8,
        "type":"imggroup",
        "content":["ep1-7.jpg","ep1-8.jpg", "ep1-9.jpg"],
        "imgClass":"rotate img-group border imgs",
        "class":""
      },
      {
        "id":9,
        "type":"text",
        "content":"I 1987 fikk Reidar datteren Rudy med sin nye kone, Pranee."
      },
      {
        "id":15,
        "type":"img",
        "content":"ep1-13.jpg",
        "class":"",
        "imgClass":"rotate-odd border"
      },
      {
        "id":9,
        "type":"text",
        "content":"Reidar, Preben og Oddrun på Prebens konfirmasjonsdag."
      },
      {
        "id":11,
        "type":"img",
        "content":"ep1-10.jpg",
        "class":"rotate-odd",
        "imgClass":"border"
      },
      {
        "id":12,
        "type":"text",
        "content":"Etter å ha forsøkt seg i hotellbransjen dro Reidar tilbake på sjøen. Han endte etterhvert opp med å seile fast for et trålerrederi på Sunnmøre."
      },
      
      {
        "id":17,
        "type":"imggroup",
        "byline": "Foto: Andrè Liohn",
        "content":["ep1-14.jpg", "ep1-20.jpg"],
        "class":"",
        "imgClass":"rotate img-group border imgs"
      },
      {
        "id":18,
        "type":"text",
        "content":'Tilig på 2000-tallet flyttet Reidar til utlandet. Etter noen år i Spania flyttet han i 2004 til Brasil. I 2007 kjøpte han en leilighet i dette boligkomplekset i Camaragibe like utenfor millionbyen Recife med sin nye samboer "Paula". I 2007 fikk Reidar og "Paula" datteren "Adele". T.h. står "Ana Lucila", datteren "Paula" har fra et tidligere forhold.'
      },
      {
        "id":19,
        "type":"imggroup",
        "content":["ep1-15.jpg","ep1-16.jpg"],
        "imgClass":"rotate img-group border imgs",
        "class":""
      },
      
      {
        "id":20,
        "type":"text",
        "content":"I 2012 fikk Rudy en datter som ble kalt opp Reidars mor. Reidar kom til Bergen for å bære barnebarnet til dåp."
      },
      {
        "id":21,
        "type":"img",
        "content":"ep1-17.png",
        "class":"",
        "imgClass":"rotate"
      },
      {
        "id":22,
        "type":"text",
        "content":"I desember 2013 skrev Reidar til søsteren Bjørg-Nina at han ville hjem til Sauda. Han kom aldri."
      },
      {
        "id":23,
        "type":"img",
        "content":"ep1-18.png",
        "class":"",
        "imgClass":"rotate-odd"
      },
      {
        "id":24,
        "type":"text",
        "content":"Det siste sikre livstegnet fra Reidar er en mail til banken i Sauda 2. januar 2014."
      },
      {
        "id":25,
        "type":"img",
        "content":"ep1-19.jpg",
        "class":"",
        "imgClass":"rotate border"
      },
      {
        "id":26,
        "type":"text",
        "content":"Siden årsskiftet 2013-2014 har verken Rudy eller noen andre familiemedlemmer i Norge hatt kontakt med Reidar. Han ble sporløst borte fra dem."
      },
    ],
    ep2: [
      {
        "id":1,
        "type":"img",
        "content":"ep2-1.png",
        "imgClass":"rotate-odd"
      },
      {
        "id":2,
        "type":"text",
        "content":"Like før jul i 2013 hadde Reidar skrevet en Messenger-melding til sin niese Kristina Berge Nygård om at han i januar 2014 ville flytte inn i et hus hun har i Sauda. Men 8. januar mottok Kristina en melding fra Reidar som var skrevet så gebrokkent at hun reagerte."
      },
      {
        "id":3,
        "type":"img",
        "content":"ep2-2.png",
        "imgClass":"rotate"
      },
      {
        "id":4,
        "type":"text",
        "content":"3. februar ble det sendt tiggemeldinger fra Reidars Messenger-konto til familiemedlemmer og venner der han ber om 15 000 kroner. Datteren Rudy skjønte at det ikke var faren som sendte meldingen til henne, selv om vedkommende som stod bak visste at Reidar pleide å kalle henne “gullet”."
      },
      {
        "type":"imggroup",
        "content":["ep2-11.png","ep2-11-2.png"],
        "imgClass":"rotate img-group screenshots",
        "class":""
      },
      {
        "id":4,
        "type":"text",
        "content":"Eks-kjæresten “Paula” i Brasil hevder i februar og mars at hun fortsatt har kontakt med Reidar. Hun skriver hun at hun har oppsøkt ham i et hus han leier i Ponta de Pedra, for å spørre hvem som kan stå bak de mystiske, gebrokne meldingene. Ifølge “Paula” peker Reidar på en kvinne fra Kapp Verde."
      },
      {
        "id":5,
        "type":"img",
        "content":"ep2-4.png",
        "imgClass":""
      },
      {
        "id":6,
        "type":"text",
        "content":"“Paula” kommuniserer i samtalene med Reidars norske slektninger både på norsk og portugisisk. Reidars bror Leif Kåre skriver at familien vurderer å koble inn politiet. “Paula” sier at i Brasil vet alle at Reidar har det bra, og at hun ikke kan tvinge ham til å ringe hjem til Norge."
      },
      {
        "id":1,
        "type":"img",
        "content":"ep2-5.png",
        "imgClass":"rotate"
      },
      {
        "id":2,
        "type":"text",
        "content":"Også i mars og april fortsetter de underlige, gebrokne meldingene å komme til Reidars familie i Norge. De blir mer og mer engstelige for at noe alvorlig har hendt Reidar."
      },
      {
        "id":5,
        "type":"img",
        "content":"ep2-6.png",
        "imgClass":"rotate-odd"
      },
      {
        "id":6,
        "type":"text",
        "content":"17. mars 2014 gikk Reidars to søstre i Sauda til politiet for å melde broren savnet i Brasil."
      },
      {
        "id":5,
        "type":"img",
        "byline": "Foto: Finn E. Våga",
        "content":"ep2-7.jpg",
        "imgClass":"rotate border"
      },
      {
        "id":6,
        "type":"text",
        "content":"Politimannen Thomas Wahl i Sauda og Suldal lensmannsdistrikt mottok anmeldelsen fra de to søstrene. Han frykter at Reidar Edvin Sandanger kan ha blitt utsatt for en alvorlig kriminell handling i Brasil."
      },
      {
        "id":5,
        "type":"img",
        "content":"ep2-8.png",
        "imgClass":""
      },
      {
        "id":6,
        "type":"text",
        "content":"Ikke lenge etter at Reidars bankkonto blir sperret, er Reidar plutselig aktiv på Facebook igjen. Da hadde profilen hans hadde vært stengt i flere uker. Tilsynelatende er han sint, og bruker emojier for å uttrykke irritasjon og forargelse. Ifølge familie brukte ikke Reidar emojier for å uttrykke sinnstilstand."
      },
      {
        "id":1,
        "type":"imggroup",
        "content":["ep2-10.png", "ep2-10-2.png"],
        "imgClass":"rotate img-group screenshots"
      },
      {
        "id":2,
        "type":"text",
        "content":" "
      },
      {
        "id":5,
        "type":"img",
        "content":"ep2-9.png",
        "imgClass":""
      },
      {
        "id":6,
        "type":"text",
        "content":"Like etter at Reidars bankkonto ble sperret, fortalte eks-kjæresten “Paula” i Brasil også til Reidars bror Leif Kåre at Reidar hadde solgt en leilighet til hennes bror og tatt pengene. Selv hadde hun knapt noe å handle medisiner, betale barnas skolebuss eller kjøpe mat for nå når hun ikke lenger kunne bruke Reidars bankkort."
      },
    ],
    ep3: [
      {
        "type":"img",
        "content":"ep3-1.png",
        "byline":"Foto: privat",
        "imgClass":"rotate border"
      },
      {
        "type":"text",
        "content":"I 2015 ble Reidar Edvin Sandangers lillebror Leif Kåre alvorlig syk. I hans begravelse i januar 2016 ba familien presten om også å lese opp minneord for Reidar, som hadde forsvunnet for dem to år tidligere."
      },
      {
        "type":"img",
        "content":"ep3-2.jpg",
        "imgClass":"rotate-odd border"
      },
      {
        "type":"text",
        "content":"I 2007 fikk Reidar datteren “Adele” med sin brasilianske samboer “Paula”. Familien i Norge var bekymret for hvilke konsekvenser det kunne få for lille “Adele” om politiet ble koblet inn."
      },
      {
        "id":1,
        "type":"imggroup",
        "content":["ep3-2-1.png", "ep3-2-2.png", "ep3-2-3.png", "ep3-2-4.png"],
        "imgClass":"rotate img-group letter",
      },
      {
        "id":2,
        "type":"text",
        "content":"I løpet av det første halve året etter at Reidar ble etterlyst gjennom Interpol, mottok norsk politi fire korte meldinger fra sine kolleger i Brasil. Deretter ble det helt stille. (Aftenbladet har gitt fiktive navn til Reidars familie i Brasil.)"
      },
      {
        "type":"img",
        "content":"ep3-8.jpeg",
        "byline":"Foto: Henrik Mundal Andreassen, Sunnhordland",
        "imgClass":"rotate border"
      },
      {
        "type":"text",
        "content":"Politiinspektør Thomas Utne Pettersen i daværende Haugaland og Sunnhordland politidistrikt (nå en del av Sør-Vest politidistrikt) innrømmer at politiet kunne gjort mer for å komme til bunns i hva som skjedde med Reidar."
      },
      {
        "type":"img",
        "content":"ep3-7.png",
        "imgClass":"rotate"
      },
      {
        "type":"text",
        "content":"Politifolkene i Sauda og Haugesund som jobbet med Reidar-saken ville be kollegene i Brasil om etterforskningsbistand. Det viste seg å ikke være enkelt. I 2015 ble det sendt flere skriv mellom politikammeret i Haugesund og Statsadvokatembetet i Stavanger før alt stoppet opp."
      },
      
    ],
    ep4: [
      {
        "type":"img",
        "content":"ep4-1.png",
        "byline":"Faksimile fra Haugesunds Avis, 16. november 1983.",
        "imgClass":"rotate"
      },
      {
        "type":"text",
        "content":"Reidar hadde store planer da han i 1983 kjøpte Grand Hotel i Sauda, med den legendariske baren Manilla i kjelleren."
      },
      {
        "type":"img",
        "content":"ep4-2.jpg",
        "imgClass":"rotate-odd border"
      },
      {
        "type":"text",
        "content":"Inge Steen i Sauda tenker fortsatt mye på Reidar, kameraten som bare forsvant sporløst ved årsskiftet 2013/14."
      },
      {
        "type":"img",
        "content":"ep4-3.png",
        "imgClass":"rotate border"
      },
      {
        "type":"text",
        "content":"I 1977 giftet Reidar seg med Oddrun Birkeland hjemme i Sauda. Selv om de ble skilt noen år senere, hadde Oddrun kontakt med ham helt til han forsvant for mer enn syv år siden."
      },
      {
        "type":"img",
        "content":"ep4-4.png",
        "byline":"Foto: Jan Nordtveit",
        "imgClass":"rotate-odd border"
      },
      {
        "type":"text",
        "content":"I juni 2012 kom Reidar hjem til Sauda for å markere at det var 50 år siden 1947-årskullet var konfirmanter.  Dette var siste gang han var i hjembygda."
      },
      {
        "type":"img",
        "content":"ep4-chat.png",
        "imgClass":""
      },
      {
        "type":"text",
        "content":"Denne Messenger-meldingen ble 3. april 2014 - over tre måneder etter at Reidar forsvant - sendt til en kollega i rederiet han jobbet for. Kvinnen som mottok meldingen skulle senere fortelle at hun skjønte at noe var fullstendig galt med Reidar da hun leste den."
      },
      {
        "type":"img",
        "content":"ep4-5.png",
        "imgClass":"rotate"
      },
      {
        "type":"text",
        "content":"Mot slutten av 2013 gikk Reidar tilsynelatende tom for penger i Brasil, og ba sin faste bankkontakt hjem i Sauda hjelpe ham med en nødoverførsel på 3 000 dollar. Reidar følte ikke pengene kom fort nok, og purret på overførselen."
      },
      {
        "type":"img",
        "content":"ep4-6.png",
        "imgClass":"rotate-odd "
      },
      {
        "type":"text",
        "content":"I løpet av flere år hadde Reidar overført til sammen mer enn én million kroner til en kvinne som tilsynelatende ikke eksisterer - Francisca Niedsa/Niedesa (begge navnene forekommer)."
      },
      {
        "type":"img",
        "content":"ep4-7.png",
        "imgClass":"rotate "
      },
      {
        "type":"text",
        "content":"10. januar 2014 ble det postet på engelsk på Reidars Facebook-side at han skulle på strandferie. Den som la det ut, la på en emoji som viste at Reidar følte seg glad. De som kjente ham, sier Reidar ikke pleide å bruke emojier på meldingene sine."
      },
    ],
    ep5: [
      {
        "type":"imggroup",
        "content":["ep5-1.png", "ep5-2.png"],
        "imgClass":"rotate border img-group imgs"
      },
      {
        "type":"text",
        "content":"Aftenbladet oppsøker eiendomsregisteret i Camaragibe like utenfor Recife for å undersøke hvem som eier leiligheten nordmannen Reidar Edvin Sandanger bodde i da han forsvant for drøyt syv år siden."
      },
      {
        "type":"imggroup",
        "content":["ep5-3.png", "ep5-4.png"],
        "imgClass":"rotate border img-group imgs"
      },
      {
        "type":"text",
        "content":"Flavia er en slags borettslagsleder i leilighetskomplekset der Reidar bodde fra 2007. Mannen til høyre er Andre Liohn, Aftenbladets fotograf og tolk under oppholdet i Brasil."
      },
      {
        "type":"img",
        "content":"ep5-5.png",
        "byline":"Foto: André Liohn",
        "imgClass":"rotate border img-group imgs"
      },
      {
        "type":"text",
        "content":"Dette er Reidars familie i Brasil. I 2005 møtte han «Paula» (i midten) på en strand i Recife. Hun hadde datteren «Ana Lucila» (t.v) fra før. I 2007 fikk «Paula» og Reidar datteren «Adele», og samme år kjøpte nordmannen denne leiligheten i Recife."
      },
      {
        "type":"imggroup",
        "content":["ep5-6.png", "ep5-7.png"],
        "imgClass":"rotate img-group imgs"
      },
      {
        "type":"text",
        "content":"Hjemme hos «Paula» lå alle Reidars personlige dokumenter, samt bankkortet og kodebrikken som ble sendt til nordmannen i Brasil ved årsskiftet 2013/14."
      },
      
    ],
    ep6: [
      {
        "type":"imggroup",
        "content":["ep6-1.png","ep6-2.png"],
        "imgClass":"border rotate img-group imgs",
        "class":""
      },
      {
        "type":"text",
        "content":"Ponta de Pedras er en sliten småby med en flott strand halvannen times biltur nord for Recife. Da vi møtte “Paula” dagen før, sa hun at det var til dette stedet Reidar skulle da han forsvant også for henne i slutten av mars 2014."
      },
      {
        "type":"img",
        "content":"ep6-3.png",
        "imgClass":"border rotate ",
        "class":""
      },
      {
        "type":"text",
        "content":"I et par timer hadde vi vært innom alle barer og butikker i Ponta Pedra med bilder av Reidar. Ingen kunne med sikkerhet si at de hadde sett den savnede nordmannen."
      },
      {
        "type":"imggroup",
        "content":["ep6-4.png","ep6-5.png"],
        "imgClass":"border rotate img-group imgs",
        "class":""
      },
      {
        "type":"text",
        "content":"Ekteparet Carlo Pistone og Eroni Heinen Buss driver Pousada Oceanu’s i Ponta de Pedra. Eroni (t.h) mener å huske en eldre utlending og en ung kvinne som var innom på tiden da Reidar forsvant, men kjenner ikke igjen Reidar på bilder. Journalist Hans Petter Aass (t.v) og fotograf André Liohn."
      },
      {
        "type":"img",
        "content":"ep6-6.png",
        "imgClass":"border rotate ",
        "class":""
      },
      {
        "type":"text",
        "content":"På en avsides del av kirkegården Cemitério Parque das Flores gravlegges alle ukjente døde i Recife-området. Hvert eneste år ender flere hundre mennesker som myndighetene ikke kjenner identiteten til her. På bildet er journalist Elisabeth Risa og fotograf André Liohn."
      },
      {
        "type":"img",
        "content":"ep6-7.png",
        "imgClass":"border rotate-odd ",
        "class":""
      },
      {
        "type":"text",
        "content":"«Paula» hjemme i stuen der hun i flere år bodde med Reidar. I bakgrunnen henger en klokkestreng som Reidar arvet etter sin mor i Sauda."
      },
      {
        "type":"img",
        "content":"ep6-8.png",
        "imgClass":"rotate",
        "class":""
      },
      {
        "type":"text",
        "content":"Her er starten på det mystiske brevet som lå blant Reidars dokumenter hjemme hos “Paula”. Brevet er datert 7. mars 2014, mer enn to måneder etter at alle hjemme i Norge mistet kontakten med ham."
      },
      {
        "type":"img",
        "content":"ep6-9.png",
        "imgClass":"rotate-odd ",
        "class":""
      },
      {
        "type":"text",
        "content":"Ifølge et dokument fra det føderale politiet i delstaten Pernambuco, der Recife er hovedstad, ble Reidars savnet-sak henlagt senest 22. november 2017. Dokumentet ble funnet hjemme hos «Paula»."
      },
      {
        "type":"img",
        "content":"ep6-10.png",
        "imgClass":"border rotate ",
        "class":""
      },
      {
        "type":"text",
        "content":"Bak dette gitteret drev Jose Cesario Raimundo, blant venner mest kjent som «Gabriel», i mange år Popy Bar i Reidars nabolag i Camaragibe. Ifølge «Paula» var dette Reidars favorittbar. I dag er Popy nedlagt, men fortsatt selger «Gabriel» øl gjennom gitteret."
      },
      {
        "type":"img",
        "content":"ep6-11.png",
        "imgClass":"border rotate-odd ",
        "class":""
      },
      {
        "type":"text",
        "content":"TV-apparatet som Reidar kjøpte for å kunne se DVD’er med sin brasilianske favorittsanger, henger fortsatt inne i lokalene til det som en gang var Popy bar."
      },
    ],
    ep7: [
      {
        "type":"img",
        "content":"ep7-1.png",
        "imgClass":"rotate",
        "class":""
      },
      {
        "type":"text",
        "content":"I desember 2013 - bare dager før han forsvant - sendte Reidar en stor forsendelse i en konvolutt til ligningsmyndighetene. Han ville forsøke å finne en ordning slik at han kunne kvitte seg med gammel skattegjeld."
      },
      {
        "type":"img",
        "content":"ep7-2.png",
        "imgClass":"rotate-odd",
        "class":''
      },
      {
        "type":"text",
        "content":'Thomas Mathiesen i Etterforsker1 Gruppen AS har kikket på 4-tallet i datoen i det mystiske, håndskrevne brevet fra Reidar har skrevet: "Det er ikke sannsynlig at 4-tallet et forfalsket, men buen er litt spesiell og stiller spørsmål."'
      },
      {
        "type":"img",
        "content":"ep7-3.png",
        "imgClass":"rotate",
        "class":''
      },
      {
        "type":"text",
        "content":'Vi sendte et fotografi av det håndskrevne brevet også til Norges mest erfarne skriftgransker, Reidun Wilhelmsen. Hun har flere års erfaring fra Kripos, og har nå i over 20 år drevet sitt eget firma som tar oppdrag for både privatpersoner, det offentlige og næringslivet.'
      },
      {
        "type":"img",
        "content":"ep7-4.png",
        "imgClass":"rotate-odd",
        "class":''
      },
      {
        "type":"text",
        "content":'I februar 2014 fortalte “Paula” til Reidars datter Rudy i Bergen at Reidar ikke trengte penger fordi hadde dratt med pengene etter at han solgt en leilighet til hennes bror.'
      },
      {
        "type":"imggroup",
        "content":["ep7-5a.png","ep7-5b.png"],
        "imgClass":"rotate phone img-group imgs",
        "class":""
      },
      {
        "type":"text",
        "content":'“Paulas” bror sier til oss han ikke betalte et stort pengebeløp til Reidar, slik “Paula” hevdet. “Han forsvant definitivt ikke med penger fra salg av leiligheten”, skriver broren. Han skriver også at moren måtte ta opp et lån for å ordne opp med søsteren etter at Reidar ble borte.'
      },
      {
        "type":"imggroup",
        "content":["ep7-6a.png","ep7-6b.png","ep7-6c.png"],
        "imgClass":"rotate img-group imgs",
        "class":""
      },
      {
        "type":"text",
        "content":'Reidar selv oppga til ligningsmyndighetene 10. desember 2013, bare drøyt tre uker før han forsvant sporløst at han i april 2014 skulle selge en av leilighetene til “Paulas” mor. Han ba derfor om betalingsutsettelse.'
      },
      {
        "type":"imggroup",
        "content":["ep7-7a.png","ep7-7b.png"],
        "imgClass":"rotate img-group imgs",
        "class":""
      },
      {
        "type":"text",
        "content":'På Facebook-profilen til en slektning av “Paula” ligger bilder som viser at hun feiret jul og nyttår med en annen mann både i 2013 og 2014. “Paula” selv hevder hun var sammen med Reidar julen 2013, og ga oss bilder som skulle vise dette. Bildene av Reidar var imidlertid fra 2012, ifølge Facebook-profilene til andre familiemedlemmer. Bildene er senere fjernet.'
      },
      {
        "type":"img",
        "content":"ep7-8.png",
        "imgClass":"rotate-odd",
        "class":''
      },
      {
        "type":"text",
        "content":'Femte februar 2014 skrev “Paula” til Rudy at hun og Reidar ikke lenger er kjærester, kun venner. Syv år senere har hun en annen oppfatning av hva slags forhold hun hadde til nordmannen før han forsvant.'
      },
      {
        "type":"img",
        "content":"ep7-9.png",
        "imgClass":"rotate",
        "class":''
      },
      {
        "type":"text",
        "content":'Vi ba språkeksperter ved Universitetet i Oslo undersøke de gebrokne meldingene som angivelig var sendt fra Reidar til familie og venner. Professor Anne Golden ved Institutt for lingvistiske og nordiske studier mener noen som ikke har norsk som morsmål står bak.'
      },
      {
        "type":"img",
        "content":"ep7-10.png",
        "imgClass":"rotate-odd",
        "class":''
      },
      {
        "type":"text",
        "content":'I 2007 kjøpte Reidar to naboleiligheter i Camaragibe, og slo dem sammen til én boenhet for seg og familien. Etter at Reidar forsvant, satt “Paula” opp en vegg mellom de to enhetene for å leie ut den ene halvdelen. Nylig varslet hun at hun også vil leie ut den andre leiligheten.'
      },
      {
        "type":"img",
        "content":"ep7-11.png",
        "imgClass":"rotate",
        "class":''
      },
      {
        "type":"text",
        "content":'“Paula” har den siste tiden leid ut flere leiligheter. I november 2020 la “Paula” ut en leilighet i tredje etasje i dette boligkomplekset i nabobyen Sao Lourenco da Mata, nabobyen til Camaragibe, for leie. Hun avviser at Reidar har noe med denne leiligheten å gjøre. “Paulas” Facebook-profil ble nylig fjernet.'
      },
    ],
    ep8: [
      {
        "type":"imggroup",
        "content":["ep8-1a.png","ep8-1b.png","ep8-1c.png","ep8-1d.png"],
        "imgClass":"rotate img-group small",
        "class":""
      },
      {
        "type":"text",
        "content":'“Paula” fortalte Aftenbladet at hun kun hadde et kort forhold med “Ramos” før Reidar forsvant. Sent i 2020 og tidlig i 2021 postet de to plutselig en rekke kjærlighetserklæringer til hverandre på sosiale medier. I en av dem sendte “Paula” en takk til “Ramos” for åtte år med mye kjærlighet og omsorg..'
      },
      {
        "type":"img",
        "content":"ep8-2.png",
        "imgClass":"rotate",
        "class":''
      },
      {
        "type":"text",
        "content":'På Facebook-profilen til en av “Paulas” nærmeste slektninger fant vi også bilder av “Ramos” i selskap med “Paula” sin familie høsten 2016. Etter at Aftenbladet konfronterte “Paula” med bildene av “Ramos” sammen med hennes familie i årene etter at Reidar ble borte, ble de fjernet fra slektningenes Facebook-profil.'
      },
      {
        "type":"img",
        "content":"ep8-3.png",
        "imgClass":"rotate-odd",
        "class":''
      },
      {
        "type":"text",
        "content":'2. januar 2014 sendte Reidar en mail til banken i Sauda, der han fortalte at han endelig hadde mottatt nødoverførselen på 3000 dollar fra banken sin. I dagene i forveien hadde han nærmest tryglet sin kundekontakt i Sparebanken Vest om å få fortgang på overføringen - fordi han var i beit for penger. Dette dokumentet viser imidlertid at Reidar - eller noen andre - allerede samme dag som han mottok pengene videreførte dem til kontoen til “Francisca Niedesa” - som altså er navnet som står på kontoen  til Reidars eks-kjæreste “Paula”.'
      },
      {
        "type":"img",
        "content":"ep8-4.png",
        "imgClass":"rotate",
        "class":''
      },
      {
        "type":"text",
        "content":'Noen måneder etter at vi kom hjem fra Brasil, fortalte politimannen som skulle sette oss i kontakt med de ansvarlige for etterforskningen av Reidars forsvinning hvorfor han ble plutselig ble borte for oss. Det føderale politiet ville ikke snakke med journalister om saken.'
      },
      {
        "type":"imggroup",
        "content":["ep8-5a.png","ep8-5b.png"],
        "imgClass":"rotate phone img-group imgs",
        "class":""
      },
      {
        "type":"text",
        "content":'Talsmann Giovani Santoro ved det føderale politiet i delstaten Pernambuco hevder Reidar like gjerne kan ha forsvunnet i et annet land enn Brasil, og at brasiliansk politi derfor ikke kan gjøre mer i saken. Santoro besvarte aldri oppfølgingsspørsmål.'
      },
      {
        "type":"img",
        "content":"ep8-6.png",
        "imgClass":"rotate",
        'byline':"Foto: privat",
        "class":''
      },
      {
        "type":"text",
        "content":'Belle, Reidars barnebarn i Bergen, har hatt mareritt om at noen tok med morfaren ut i en skog og skjøt ham.'
      },
      {
        "type":"img",
        "content":"ep8-7.png",
        "imgClass":"rotate-odd",
        'byline':"Foto: Finn E. Våga",
        "class":''
      },
      {
        "type":"text",
        "content":'Familien håper fortsatt at den én dag skal få vite hvordan Reidars liv endte. Og at han én dag kanskje skal få hvile under gravsteinen som allerede står der.'
      },
    ]
  },
  timelines: 
    {
      reidar: [
        {
          "id": 1,
          "dato": 2012,
          "hendelse": "Brudd mellom Reidar og Paula i Brasil. Reidar har to leiligheter i Recife, til seg og Paulas familie."
        },
        {
          "id": 2,
          "dato": "Fra januar 2013",
          "hendelse": "Etter bruddet tilbringer Reidar friperioder fra tråleren “Nordstar” på Kapp Verde."
        },
        {
          "id": 3,
          "dato": "Tidlig 2013",
          "hendelse": "Reidar til banken i Sauda: Noen sender meldinger i hans navn. Ber dem ringe før de overfører penger."
        },
        {
          "id": 4,
          "dato": "8. mai 2013",
          "hendelse": "Ligningsetaten: Reidar skylder nær én million kroner etter konkurs i Norge drøyt ti år tidligere."
        },
        {
          "id": 5,
          "dato": "Sommer 2013",
          "hendelse": "Tar ut 285.000 kroner fra kontoen sin mens han er på Kapp Verde, sier opp jobben på norsk tråler."
        },
        {
          "id": 6,
          "dato": "23. oktober 2013",
          "hendelse": "Reiser til Brasil for jul og nyttår. Sier han skal selge boligen der eks-kjærestens mor og bror bor."
        },
        {
          "id": 7,
          "dato": "Tidlig desember 2013",
          "hendelse": "Gir flere slektninger beskjed om at han vil til Norge i januar, muligens for godt."
        },
        {
          "id": 8,
          "dato": "8. og 10. desember 2013",
          "hendelse": "Varsler ligningsmyndighetene at han vil selge leilighet i Brasil. Ber om utsatt gjeldsbetaling."
        },
        {
          "id": 9,
          "dato": "Jul 2013",
          "hendelse": "Reidar er ikke med på bilder Paula poster fra familieselskaper i Recife. Men det er hennes nye kjæreste."
        },
        {
          "id": 10,
          "dato": "30. desember 2013",
          "hendelse": "Reidar kontakter banken i Sauda: Må ha nødlån på 3000 USD. Etterlyser kredittkort."
        },
        {
          "id": 11,
          "dato": "2. januar 2014",
          "hendelse": "Siste sikre livstegn. Bekrefter mottatt kort og nødlån. Sendes videre til konto til mystisk kvinne."
        },
        {
          "id": 12,
          "dato": "Januar-april 2014",
          "hendelse": "Reidars bankkort brukes flere steder i Brasil. Verken barn, søsken eller banken får kontakt."
        },
        {
          "id": 13,
          "dato": "8. januar 2014",
          "hendelse": "Reidars niese får melding på gebrokkent norsk om at han likevel ikke kommer til Sauda."
        },
        {
          "id": 14,
          "dato": "22. januar 2014",
          "hendelse": "Drøyt 20.000 kroner går fra Reidars konto til samme kvinne som fikk nødlånet 2. januar."
        },
        {
          "id": 15,
          "dato": "30. januar 2014",
          "hendelse": "Datter Rudy har fødselsdag, ingen hilsen fra faren. Gebrokken melding om at han vil leie strandhus."
        },
        {
          "id": 16,
          "dato": "3. februar 2014",
          "hendelse": "Flere familiemedlemmer og bekjente får tiggemeldinger på gebrokkent norsk fra Reidar."
        },
        {
          "id": 17,
          "dato": "7. februar 2014",
          "hendelse": "Merkelige meldinger fra Reidar til Rudy. Hun svarer de varsler politiet om han ikke ringer. Ingen svar."
        },
        {
          "id": 18,
          "dato": "9. februar 2014",
          "hendelse": "Paula forteller Rudy at hun oppsøkte Reidar i småbyen Ponta de Pedras."
        },
        {
          "id": 19,
          "dato": "20. februar 2014",
          "hendelse": "Rudy ber Paula sørge for at Reidar ringer om han kommer innom på 67-årsdagen."
        },
        {
          "id": 20,
          "dato": "26. februar 2014",
          "hendelse": "Reidar blir 67 år. Paula til Rudy: Reidar var innom et par dager før, men er sur på dem i Norge."
        },
        {
          "id": 21,
          "dato": "7. mars 2014",
          "hendelse": "Et mystisk brev datert denne dagen dukker opp i Aftenbladets undersøkelser av forsvinningen."
        },
        {
          "id": 22,
          "dato": "8. mars 2014",
          "hendelse": "Melding på Fb-siden til Reidar: “Jeg, vil, bli, hotelleier, på, Ponta de Pedra, i, januar, 2015”."
        },
        {
          "id": 23,
          "dato": "17. mars 2014",
          "hendelse": "Søster Bjørg-Nina melder Reidar savnet hos politiet i Sauda. Varsel internasjonalt to dager senere."
        },
        {
          "id": 24,
          "dato": "28. mars 2014",
          "hendelse": "Flere rare og gebrokne meldinger fra Reidars messenger-konto til Rudy."
        },
        {
          "id": 25,
          "dato": "29. mars 2014",
          "hendelse": "Paula: Brasiliansk politi har vært hos henne, hun sa at “eks-mann” Reidar ikke vil ha kontakt med Norge."
        },
        {
          "id": 26,
          "dato": "30. mars 2014",
          "hendelse": "Flere måneder senere opplyser “Paula” at hun så Reidar for siste gang denne dagen."
        },
        {
          "id": 27,
          "dato": "11. april 2014",
          "hendelse": "Bankkonto stenges av Reidars familie i Norge. Paula skriver hun fortsatt har mye kontakt med eksen."
        },
        {
          "id": 28,
          "dato": "16.-18. april 2014",
          "hendelse": "På fb-profilen er Reidar “irritert”. Sinte meldinger på dårlig norsk fordi bankkontoen er stengt."
        },
        {
          "id": 29,
          "dato": "18. april. 2014",
          "hendelse": "Tilsynelatende siste gang det sendes meldinger fra Reidars konto."
        },
        {
          "id": 30,
          "dato": "21. april 2014",
          "hendelse": "Paula til Rudy: Har mistet jobb og kjæreste, har ikke hørt fra Reidar på en måned."
        },
        {
          "id": 31,
          "dato": "29. mai 2014",
          "hendelse": "Paula forteller brasiliansk politi at hun ikke har sett Reidar siden mars."
        },
        {
          "id": 32,
          "dato": "25. august 2014",
          "hendelse": "Siste chattemelding fra Rudy til faren: “Pappa, hvor er du?”"
        },
        {
          "id": 33,
          "dato": "26. mai 2017",
          "hendelse": "Oslo Byfogdembete erklærer Reidar Sandanger død. Dødsdato settes til 31. desember 2014."
        }
      ],
    etterforsking: [
      {
        "id": 1,
        "dato": "17. mars 2014",
        "hendelse": "Familien melder Reidar savnet hos politiet i Sauda etter halvannen måneds bekymring."
      },
      {
        "id": 2,
        "dato": "18. mars 2014",
        "hendelse": "Lokalt politi ber Interpol etterlyse Reidar. Varselet sendes ut internasjonalt neste dag."
      },
      {
        "id": 3,
        "dato": "19. mars 2014",
        "hendelse": "Reidar etterlyst gjennom Interpol på “Yellow Notice”. Kopi til Brasils ambassade i Norge."
      },
      {
        "id": 4,
        "dato": "24. mars 2014",
        "hendelse": "Interpol Norge sender detaljer om etterlysningen til kollegene i Brasil og norsk ambassade i Brasil."
      },
      {
        "id": 5,
        "dato": "8. april 2014",
        "hendelse": "Paula til politi i Brasil: Vet ikke hvor Reidar er, men han har det bra og vil ikke ha kontakt med Norge."
      },
      {
        "id": 6,
        "dato": "29. mai 2014",
        "hendelse": "Interpol Brasil: Eks-kjæresten sier hun ikke har sett Reidar siden mars, men at venner har sett ham."
      },
      {
        "id": 7,
        "dato": "9. juli 2014",
        "hendelse": "Felles-nordisk politisambandskvinne i Sør-Amerika mener norsk politi bør vurdere avhør av Paula."
      },
      {
        "id": 8,
        "dato": "9. juli 2014",
        "hendelse": "Legger ved dokument som viser hvordan man skal fylle ut en rettsbegjæring til Brasil, videresendes politiet i Sauda."
      },
      {
        "id": 9,
        "dato": "27. august 2014",
        "hendelse": "Interpol Norge purrer på Interpol Brasil."
      },
      {
        "id": 10,
        "dato": "28. august 2014",
        "hendelse": "Interpol Norge: Politiet i Sauda er klare “til å starte prosessen med rettsanmodning vedr avhør.”"
      },
      {
        "id": 11,
        "dato": "28. august 2014",
        "hendelse": "Interpol Norge ber om bistand til undersøkelser for å avdekke om Reidar hadde bankkonti i Brasil."
      },
      {
        "id": 12,
        "dato": "28. august 2014",
        "hendelse": "Nordisk politikontakt i Sør-Amerika vil bistå. Spør norsk politi om det pågår etterforskning i Brasil."
      },
      {
        "id": 13,
        "dato": "10. september 2014",
        "hendelse": "Siste kontakt norsk og brasiliansk Interpol: Brasiliansk politi har etterlyst og lett uten resultat."
      },
      {
        "id": 14,
        "dato": "28. november 2014",
        "hendelse": "Nordisk politisambandskvinne i Sør-Amerika: Ikke hørt fra norsk politi “sedan september”."
      },
      {
        "id": 15,
        "dato": "12. desember 2014",
        "hendelse": "Politiet i Sauda: “mye som “skurrer” i denne saken”."
      },
      {
        "id": 16,
        "dato": "16. januar 2015",
        "hendelse": "Politiinspektør skriver utkast til rettsanmodning for å få brasiliansk politi til å avhøre Paula."
      },
      {
        "id": 17,
        "dato": "19. januar 2015",
        "hendelse": "Anmodningen sendes videre til statsadvokaten i Rogaland."
      },
      {
        "id": 18,
        "dato": "4. februar 2015",
        "hendelse": "Statsadvokat returnerer anmodning til politiet, ber om flere opplysninger og hjemler."
      },
      {
        "id": 19,
        "dato": "11. juni 2015",
        "hendelse": "Politiet sender statsadvokaten ny rettsanmodning til Brasil om avhør av Paula."
      },
      {
        "id": 20,
        "dato": "22. juni 2015",
        "hendelse": "Statsadvokaten returnerer for andre gang henvendelsen: “må utformes på annen måte…”"
      },
      {
        "id": 21,
        "dato": "25. juni 2015",
        "hendelse": "Politiet ber om nærmere presisering av hva som ligger i “annen måte”."
      },
      {
        "id": 22,
        "dato": "12. august 2015",
        "hendelse": "Statsadvokaten returnerer henvendelsen og viser til “samtaler med politiinspektør”."
      },
      {
        "id": 23,
        "dato": "12. august 2015",
        "hendelse": "Ser ikke ut til å ha funnet sted ytterligere etterforskning."
      },
      {
        "id": 24,
        "dato": "9. mars 2016",
        "hendelse": "Norsk politi henlegger Reidar Sandanger-saken med henvisning til kode 016 - “utenfor straffesak”."
      },
      {
        "id": 25,
        "dato": "26. mai 2017",
        "hendelse": "Oslo Byfogdembete avsier kjennelse: Reidar Sandanger er død - omtaler en rekke forhold som mistenkelige."
      },
      {
        "id": 26,
        "dato": "22. november 2017",
        "hendelse": "Paula hos brasiliansk politi: Har ikke sett Reidar siden 30. mars 2014. Saken blir henlagt."
      }
    ]
  },
};
